// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';

const imgDimensions = (props) => {
  return ((props.bagItemCount || props.orderItemsCount > 0) && (props.isBagPage || props.spcBag)) ||
    props.isAddedToBag
    ? props.theme.spacing.ELEM_SPACING.XL
    : props.theme.spacing.ELEM_SPACING.XXL_1;
};

export const PriceSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  text-align: left;
`;

export const ATBIcon = styled.button`
  padding: 0;
  border: 0;
  position: relative;
  box-sizing: border-box;
  cursor: pointer;
  margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.MED};

  &,
  .atb-icon-image {
    width: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
    height: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
    border-radius: 50%;

    @media ${(props) => props.theme.mediaQuery.large} {
      width: ${(props) => imgDimensions(props)};
      height: ${(props) => imgDimensions(props)};
    }
  }

  .atb-icon-image {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const Title = styled(BodyCopy)`
  font-weight: ${(props) => props.theme.fonts.fontWeight.medium};
  font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy2}px;
  line-height: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  display: block;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};

  @media ${(props) => props.theme.mediaQuery.large} {
    font-weight: ${(props) => props.theme.fonts.fontWeight.normal};
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy4}px;
    line-height: ${(props) => props.theme.spacing.ELEM_SPACING.MED_2};
  }
`;

export const ImageContainer = styled.span`
  display: block;
  width: 100%;
  height: 0;
  padding-top: ${Math.ceil((329 / 264) * 100)}%;
  position: relative;
  overflow: hidden;
  margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }
`;

export default css`
  &.recommendation-tile {
    margin-right: 0;

    @media ${(props) => props.theme.mediaQuery.large} {
      margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.MED_1};
    }
  }

  .merchant-tag {
    font-weight: ${(props) => props.theme.fonts.fontWeight.normal};
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    .offer-price-tag {
      font-size: ${(props) =>
        ((props.bagItemCount || props.orderItemsCount > 0) && (props.isBagPage || props.spcBag)) ||
        props.isAddedToBag
          ? props.theme.typography.fontSizes.fs14
          : props.theme.typography.fontSizes.fs20};

      line-height: ${(props) =>
        ((props.bagItemCount || props.orderItemsCount > 0) && (props.isBagPage || props.spcBag)) ||
        props.isAddedToBag
          ? '15px'
          : '27px'};
    }
    .price-tag-wrapper {
      min-height: ${(props) =>
        ((props.bagItemCount || props.orderItemsCount > 0) && (props.isBagPage || props.spcBag)) ||
        props.isAddedToBag
          ? '30px'
          : '48px'};
    }
    .merchant-tag,
    .strike-price {
      font-size: ${(props) =>
        ((props.bagItemCount || props.orderItemsCount > 0) && (props.isBagPage || props.spcBag)) ||
        props.isAddedToBag
          ? props.theme.typography.fontSizes.fs10
          : props.theme.typography.fontSizes.fs14};
    }
    .product-name {
      font-size: ${(props) =>
        ((props.bagItemCount || props.orderItemsCount > 0) && (props.isBagPage || props.spcBag)) ||
        props.isAddedToBag
          ? props.theme.typography.fontSizes.fs12
          : props.theme.typography.fontSizes.fs16};
    }
  }
`;
